import { parseUserDoc, parseUserPrivateDoc } from '@db/Users/Common';
import { getCurrentUserId } from '@helpers/firebase/Auth';
import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { User, UserPrivate } from '@types';

export function listenToUser(
  userId: string,
  onUser: (user: User) => void,
  onError: (error: db.FirestoreError) => void
) {
  const doc = db.doc(firestore, 'users', userId);
  const onNext = (snap: db.DocumentSnapshot<db.DocumentData>) => {
    if (snap.exists()) {
      return onUser(parseUserDoc(snap));
    }
  };
  return db.onSnapshot(doc, onNext, onError);
}

export function listenToUserPrivate(
  onUserPrivate: (userPrivate: UserPrivate) => void,
  onError: (error: db.FirestoreError) => void
) {
  const currentUserId = getCurrentUserId();
  const doc = db.doc(firestore, 'users', currentUserId, 'private', currentUserId);
  const onNext = (snap: db.DocumentSnapshot<db.DocumentData>) => {
    return onUserPrivate(parseUserPrivateDoc(snap));
  };
  return db.onSnapshot(doc, onNext, onError);
}
